import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonContent, IonList, IonItem, IonInfiniteScroll, IonInfiniteScrollContent, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from './Modal_EnterPassword';
import { ViewAttachement_ExpenseImageModal } from './Modal_ViewAttachement_ExpenseImage';

//import classes from './Modal_ViewModal.module.css';
import '../../../../css/qavaApp.css';

const Backdrop = props => {
    return <div className='backdrop'/>
};

export function ViewEstimateModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [viewEstimates, setViewEstimates] = useState([]);

    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);

    let [attachment, setImageAttachement] = useState('');

    let [viewAttachementModal, setViewAttachemntModal] = useState(false);

    let [deletTracker, setDeleteTracker] = useState(null);


    useEffect(() => {


            /*
            let formData = new FormData();
            formData.append('Tracker', '74002A');
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_view_estimates',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');



                    setViewEstimates((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            projectID: cols[0],
                            estimateID: cols[1],
                            supplierName: cols[2],
                            supplierPhoneNumber: cols[3],
                            estimateDescription: cols[11],
                            dateLogged: new Date(cols[12]).toISOString().substr(0, 10),
                            totalAmount: parseFloat(cols[13]).toFixed(2),
                            attachment: cols[14],
                        })
                    });
                } 
            })
    }, []);

    function deleteEstimate(enteredPassword)
    {


        /*
        let formData = new FormData();
        formData.append('Tracker', '74002D');
        formData.append('user', acctID);
        formData.append('xEstimateID', expenseID);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        alert(totalAmount);
        alert(props.data.projectID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: deletTracker,
                user: acctID,
                xProjectID: props.data.projectID,
                xEstimateID: estimateID,
                xEstimateTotalAmount: totalAmount,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function closeModalHandler(event) {

        setViewEstimates([]);
        props.closeModal(event);
    }
 
    function viewEstimateDetailsHandler(event) {


        setEstimateID(event[1]);
        setTotalAmount(event[2]);


        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function viewDeleteEstimateHandler(event) {


        setShowPasswordModal(event[0]);
        setEstimateID(event[1]);
        setDeleteTracker(event[2])
        setTotalAmount(event[3])

    }

    function onSubmitPasswordHandler(event)
    {
        deleteEstimate(event);
    }


    function viewEstimateAttachmentHandler(event) {

        //alert('In viewExpenseInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        setTotalAmount(event[3]);
        setImageAttachement(event[4]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }


    return (

        <React.Fragment> 
           

                        <IonGrid className='appGridContent'>
                            <IonRow >
                                    <IonCol size='3'> <h3> Supplier Name </h3> </IonCol>
                                    {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                    {/*<IonCol className='appGridCol' size='3'> <h3> Estimate Description </h3> </IonCol>*/}
                                    <IonCol size='3'> <h3> Date Logged </h3> </IonCol>
                                    <IonCol size='3'> <h3> Total Amount </h3> </IonCol>                                        
                                    <IonCol size='3'> <h3> Action </h3> </IonCol>
                            </IonRow>
                        {viewEstimates.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.expenseID}>
                                        <IonCol size='3'>{detailData.supplierName}</IonCol>
                                        {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                        {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                        <IonCol size='3'>{detailData.dateLogged}</IonCol>
                                        <IonCol size='3'>{detailData.totalAmount}</IonCol>
                                        <IonCol size='3'>

                                            <IonButton className='appListButton' onClick={() => viewEstimateAttachmentHandler([true, detailData.unitAmount, detailData.quantity, detailData.totalAmount, detailData.attachment])}> View </IonButton>
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteEstimateHandler([true, detailData.estimateID, '74002D_delete_estimate_project_hard', detailData.totalAmount])}> H-Delete </IonButton>}
                                            {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteEstimateHandler([true, detailData.estimateID, '74002D_delete_estimate_project_soft', detailData.totalAmount])}> S-Delete </IonButton>}
                                    
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}
                        </IonGrid>

                        <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

                        <ViewAttachement_ExpenseImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                totalAmount: totalAmount, 
                                                fileLocation: attachment, 
                                                }}></ViewAttachement_ExpenseImageModal>


        </React.Fragment>

    )
}